import React from 'react'
import { NaviGate } from "../../../Utility/function";
import { useNavigate } from "react-router-dom";

const Customer = () => {
    const navigate = useNavigate();
    let menuItems = [
        {
            name: "Customers",
            route: "/Customers_list",
            icon: "bi bi-person-lines-fill",
            url: "assets/images/menu/customer.png",
        },
        {
            name: "Customer Credit",
            route: "/Customer_receipt",
            icon: "bi bi-clipboard-data",
            url: "assets/images/menu/manufacture.png",
        },
    ]
    const handleCardClick = (route) => {
        navigate(route);
    };
    return (
        <div className="my-4 mx-3 pb-5 ">
            <NaviGate />
            <div className="product-grid row  d-flex justify-content-center align-items-center" style={{ padding: "10 25px", minHeight: "80vh", }}>
                {menuItems
                    // .filter((item) =>
                    //     item.name.toLowerCase().includes(Search.toLowerCase())
                    // )
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2 " key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body ">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Customer
